/**************************************************************************************************
//
//  Description: Display list of ASD items
//
//  Copyright:    © 2020 - 2021 Aligned Assets Limited
//
//--------------------------------------------------------------------------------------------------
//
//  Modification History:
//
//  Version Date     Modifier            Issue# Description
//#region Version 1.0.0.0 changes
//    001   23.03.21 Peter Bryden        WI39243 refactored Item from AAAssociatedStreetDataList to hold state context for special designations
//#endregion Version 1.0.0.0 changes
//
//--------------------------------------------------------------------------------------------------
//#endregion */

/* #region imports */
import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Collapse from '@material-ui/core/Collapse';

import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Avatar from '@material-ui/core/Avatar';
import Typography from '@material-ui/core/Typography';
import IconButton from "@material-ui/core/IconButton";
import { Tooltip } from "@material-ui/core";

import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';

import PeopleRoundedIcon from '@material-ui/icons/PeopleRounded';
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined';
import BlurOnIcon from '@material-ui/icons/BlurOn';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';

import { brown, yellow, pink, green } from "@material-ui/core/colors";

import AAAssociatedStreetDataListItem from './AAAssociatedStreetDataListItem'
import { useAAAssociatedStreetDataListState, useAAAssociatedStreetDataUpdateState } from './AAAssociatedStreetDataListContext';

/* #endregion imports */

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    maxWidth: 450,
    backgroundColor: theme.palette.background.paper,
  },
  small: {
    width: theme.spacing(2),
    height: theme.spacing(2),
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
  nested_1: {
    paddingLeft: theme.spacing(10),
  },
  pink: {
    color: theme.palette.getContrastText(pink[500]),
    backgroundColor: pink[500],
  },
  brown: {
    color: theme.palette.getContrastText(brown[500]),
    backgroundColor: brown[500],
  },
  yellow: {
    color: theme.palette.getContrastText(yellow[500]),
    backgroundColor: yellow[500],
  },

}));

const AAAssociatedStreetDataTieredListItem = ({ title, type, colour, data, editable, itemSelect, itemAdd, tiers }) => {
  const classes = useStyles();
  const isEditable = editable;

  const getOpen = useAAAssociatedStreetDataListState();
  const toggleOpen = useAAAssociatedStreetDataUpdateState();

  const [open, setOpen] = useState(getOpen(title))

  const handleOpenClick = () => {
    setOpen(!open);
    toggleOpen(title);
  };

  const avatarColours = [{ "colour": "brown", "classesName": classes.brown },
  { "colour": "yellow", "classesName": classes.yellow },
  { "colour": "pink", "classesName": classes.pink }];

  avatarColours.find((x) => x.colour === colour);

  return (
    <React.Fragment>
      <ListItem button className="asd-ListItem" onClick={handleOpenClick}>
        {open ? <ExpandLess /> : <ExpandMore />}
        <ListItemIcon>
          <ReportProblemOutlinedIcon className={classes.yellow} />
        </ListItemIcon>
        <ListItemText
          primary={<Typography className="form__component" variant="subtitle1"><strong>{title}</strong></Typography>}
          secondary={<React.Fragment>
            <Typography variant="subtitle2">{type}</Typography>
            {isEditable ?
              <IconButton onClick={() => itemAdd(data ? data.length : 0)}  size="small">
                <Tooltip title="Add" arrow placement="right">
                  <AddCircleOutlineIcon style={{ color: green[500] }} />
                </Tooltip>
              </IconButton>
              : null}
          </React.Fragment>} />
        <ListItemAvatar>
          <Avatar className={classes.small}>
            <Typography variant="caption">
              {`${data ? data.length : 0} `}
            </Typography>
          </Avatar>
        </ListItemAvatar>

      </ListItem>
      <Collapse in={open} timeout="auto">
        {tiers && tiers.map((rc, index) => (
          <List component="div" disablePadding key={`${title}_${index}`}>
            <AAAssociatedStreetDataListItem title={`${tiers.find(g => g.id === rc.id).name}`} colour="yellow"
              itemSelect={(pkId, dataIdx, dataLength, wholeRoad) => itemSelect(pkId, dataIdx, dataLength, wholeRoad)}
              data={data.filter(x => x.tier_id === rc.id)}
              editable={isEditable} />
          </List>
        ))}
      </Collapse>
    </React.Fragment>
  );
};

export default AAAssociatedStreetDataTieredListItem;
